import React from 'react'
import { useTranslation } from 'react-i18next'
import { ListGroup, ListGroupItem } from 'reactstrap'
import parse from 'react-html-parser'

const StartingPoint = (props) => {
  const { name, address, instructions, opening_hours, gmap_link, location_point_type } = props
  const { i18n } = useTranslation()

  return (
    <>
      <h2>
        {location_point_type === 'meeting_point' && (
          <>{i18n.t('product_info.meeting_point_title')}</>
        )}

        {location_point_type === 'hotel_pickup' && (
          <>{i18n.t('product_info.hotel_pickup_title')}</>
        )}

        {location_point_type === 'venue' && (
          <>{i18n.t('product_info.venue_title')}</>
        )}
      </h2>

      {['meeting_point', 'venue'].includes(location_point_type) && (
        <ListGroup>
          <ListGroupItem>
            <h3 className="py-2" style={{ fontSize: '1.1em' }}>
              {name && (
                <>
                  <i>
                    <strong>{name}</strong>{' '}
                  </i>
                  <br />
                </>
              )}
            </h3>

            {address}

            <div className="mt-1 location-instructions">{parse(instructions)}</div>

            {opening_hours && (
              <>
                <hr />
                <strong>{i18n.t('product_info.opening_hours')}</strong>
                <div>{parse(opening_hours)}</div>
              </>
            )}
          </ListGroupItem>

          {gmap_link && (
            <ListGroupItem
              className="p-2 text-center text-decoration-underline"
              style={{ fontSize: '0.85em' }}
            >
              <a
                rel="noopener noreferrer"
                target="_blank"
                className="fw-bold"
                href={gmap_link}
              >
                <i className="fa fa-map-marker-alt me-1" />
                {i18n.t('product_info.meeting_point_see_map')}
              </a>
            </ListGroupItem>
          )}
        </ListGroup>
      )}

      {location_point_type === 'hotel_pickup' && parse(instructions)}
    </>
  )
}

export default StartingPoint
